(function ($) {

    $.fn.updateImageDialog = function (options) {
        var self = $(this);

        var settings = $.extend({
            HiddenValueSelector: "#ImageURL",
            HiddenGlobalImageValueSelector: "#ImageIsInGlobalImageLibrary",
            HiddenCropToTopSelector: "",
            ImageFieldSelector: ".edit-form-image",
            SuccessHandler: undefined,
            S3RefreshURL: "",
            CropCurrentImage: true,
            CropType: "entropy",
            TargetImageFieldWidth: 100,
            TargetImageFieldHeight: 100,
            ModalImageFieldWidth: 100,
            ModalImageFieldHeight: 100,
            IncludeUnsplash: true,
            HelpTipMessage: "",
            ShowCropToFitCheckbox: false,
            CropToFitHoverText: "",
            ValidFileTypes: undefined,
            IsUsingGlobalImageLibraryFeature: false,
            FileManagerURL: "",
            FileManagerFilesPrefix: "",
        }, options);

        var unsplashClientId = "65f64eeaa6d3a0b53537d09fd977ac2bb484db2d8065e9c9c4ffa6617bc82e1b";

        var $grid = null;

        self.uploadAttemptsCount = 0;

        var newUploadsDisplayURLPrefix = GetURLPrefix(settings.IsUsingGlobalImageLibraryFeature);

        function GetURLPrefix(isGlobalImageLibrary) {
            return isGlobalImageLibrary ? "https://ylt-planner-editor-images.imgix.net/" : "https://ylt-images.imgix.net/";
        }

        function UploadSuccess(data, textStatus, xhr) {

            SetImageFromS3(encodeURIComponent(YouLi.Common.S3FileUpload.NewFileKey));
        }

        function UploadError(xhr, ajaxOptions, thrownError) {

            if (xhr.status == 403 && self.uploadAttemptsCount == 0) {
                // forbidden - try to refresh policy
                YouLi.Common.Get({
                    url: settings.S3RefreshURL,
                    suppressLoading: true,
                }).then(function (response) {
                    YouLi.Common.S3FileUpload.KeyPrefix = response.newKeyPrefix;

                    if (!settings.IsUsingGlobalImageLibraryFeature) {
                        YouLi.Common.S3FileUpload.KeyPrefix += response.newUUID;
                    }

                    YouLi.Common.S3FileUpload.Uuid = response.newUUID;
                    YouLi.Common.S3FileUpload.Policy = response.policy;
                    YouLi.Common.S3FileUpload.PolicySignature = response.policySignature;

                    // retry upload
                    self.uploadAttemptsCount++;
                    YouLi.Common.S3FileUpload.SingleFileSelected(document.querySelector(".edit-image-modal input[type='file']"), settings.ValidFileTypes, UploadSuccess, UploadError, UploadComplete);
                });
            }
            else {
                alert("There was an error attempting to upload the file. (" + thrownError + ")");
                self.uploadAttemptsCount++;
                self.find("#file").val(""); /* clear file selection to allow the same file to be selected again and trigger upload */
                YouLi.Common.UI.HideButtonLoading(self.find(".btn-done"));
            }
        }

        function UploadComplete(data, textStatus, xhr) {
        }

        function SetImageFromS3(encodedUrl) {

            self.find("#CurrentImage").attr("src", YouLi.Common.Utils.AddParametersToURL(newUploadsDisplayURLPrefix + encodedUrl, "fit=crop&crop=" + settings.CropType + (settings.ModalImageFieldHeight == "auto" ? "" : "&h=" + settings.ModalImageFieldHeight) + "&w=" + settings.ModalImageFieldWidth));

            self.find(".thumbnail-image-selectable.selected").removeClass("selected");
            self.find("#CurrentImage").addClass("selected").removeClass("hidden").attr("data-imageurl", encodedUrl);

            // New uploads get saved to the global image library if that feature is being used, so we need to update the flag here
            self.find("#CurrentImageIsInGlobalImageLibrary").val(settings.IsUsingGlobalImageLibraryFeature);

            self.find("#file").val(""); /* clear file selection to allow the same file to be selected again and trigger upload */

            // Nb: loading button will be cleared when new image is loaded

            self.find("#PurgeImageCache").attr("data-img-url", newUploadsDisplayURLPrefix + encodedUrl);
        }

        function UpdateImagesFromUnsplash(searchTerm) {

            var url = "";

            self.find("#UnsplashImages").hide();
            self.find("#UnsplashImagesNone").hide();
            self.find("#UnsplashImagesLoader").show();

            if (searchTerm === undefined) {
                // get the YouLiveToTravel user's images
                YouLi.Common.Get({
                    url: 'https://api.unsplash.com/collections/1347059/photos',
                    params: {
                        client_id: unsplashClientId,
                        page: 1,
                        per_page: 20
                    },
                    contentType: null,
                    suppressLoading: true,
                    errorCallback: function () {
                        self.find('#UnsplashImagesLoader').hide();
                        self.find('#UnsplashImagesNone').fadeIn();
                    }
                }).then(function (response) {
                    var list = self.find("#UnsplashImages");

                    self.find("#UnsplashImages .grid-item").each(function () {
                        $grid.masonry('remove', this);
                    });

                    self.find("#UnsplashImagesLoader").fadeOut(function () {

                        if (response.length > 0) {
                            self.find("#UnsplashImages").show();

                            $.each(response, function () {
                                AppendUnsplashImage(this, list);
                            });

                            $grid.imagesLoaded().progress(function () {
                                $grid.masonry('layout');
                            });
                        }
                        else {
                            self.find("#UnsplashImagesNone").fadeIn();
                        }
                    });

                });
            }
            else {
                // Search using search term
                YouLi.Common.Get({
                    url: 'https://api.unsplash.com/search/photos',
                    params: {
                        client_id: unsplashClientId,
                        page: 1,
                        per_page: 20,
                        query: searchTerm
                    },
                    contentType: null,
                    suppressLoading: true,
                    errorCallback: function () {
                        self.find('#UnsplashImagesLoader').hide();
                        self.find('#UnsplashImagesNone').fadeIn();
                    }
                }).then(function (response) {
                    var list = self.find("#UnsplashImages");

                    self.find("#UnsplashImages .grid-item").each(function () {
                        $grid.masonry('remove', this);
                    });

                    self.find("#UnsplashImagesLoader").fadeOut(function () {

                        if (response.results.length > 0) {
                            self.find("#UnsplashImages").show();

                            $.each(response.results, function () {
                                AppendUnsplashImage(this, list);
                            });

                            $grid.imagesLoaded().progress(function () {
                                $grid.masonry('layout');
                            });
                        }
                        else {
                            self.find("#UnsplashImagesNone").fadeIn();
                        }

                    });

                });
            }

        }

        function AppendUnsplashImage(image, target) {
            newImageContainer = $('<div>', {
                class: "grid-item-image-container"
            });

            newImage = $('<img/>', {
                src: image.urls.thumb,
                class: "img-responsive thumbnail-image-selectable",
            });
            newImage.attr("data-imageurl", image.urls.raw);
            newImage.attr("data-source", "unsplash");
            newImage.attr("data-download-link", image.links.download_location + "?client_id=" + unsplashClientId);

            newGridItem = $('<div/>', {
                class: 'grid-item col-xs-6 col-sm-4',
            });
            newImage.appendTo(newImageContainer);

            newAttribution = $('<div>', {
                class: "unsplash-attribution hidden-xs",
            });
            newAttribution.html("<div class='text'><a href='" + image.user.links.html + "?utm_source=YouLi&utm_medium=referral&utm_campaign=api-credit' target='_blank'><strong>" + image.user.name + "</strong></a></div>");
            newAttribution.appendTo(newImageContainer);

            newImageContainer.appendTo(newGridItem);

            target.append(newGridItem).masonry('appended', newGridItem);
        }


        function SelectionDone() {

            var selectedImageURL = self.find("img.selected").attr("data-imageurl");
            var selectedImageDownloadLocation = self.find("img.selected").attr("data-download-link");

            var isCurrentImageInGlobalLibrary = self.find("#CurrentImageIsInGlobalImageLibrary").val() == "true";

            var existingImageNewURL = selectedImageURL;
            var isUnsplashImage = self.find(".thumbnail-image-selectable.selected").attr("data-source") == "unsplash" || selectedImageURL.startsWith("http");       // For now we assume that anything starting with http is from Unsplash

            if (isUnsplashImage) {
                // reset global image library flag, as Unsplash images are not stored in the global image library
                self.find("#CurrentImageIsInGlobalImageLibrary").val("false"); 
            }
            else {
                existingImageNewURL = GetURLPrefix(isCurrentImageInGlobalLibrary) + selectedImageURL;
            }

            if (settings.ShowCropToFitCheckbox) {
                var cropToFit = self.find("#ImageCheckboxCropToFit").is(":checked");
                $(settings.HiddenCropToTopSelector).val(cropToFit);
            }

            // set the hidden values back on the main page with the new image and options
            $(settings.HiddenValueSelector).val(selectedImageURL).trigger("change");

            if ($(settings.HiddenGlobalImageValueSelector).length > 0)
                $(settings.HiddenGlobalImageValueSelector).val(self.find("#CurrentImageIsInGlobalImageLibrary").val());

            RefreshImagePreview(settings.ImageFieldSelector, settings.CropCurrentImage, false);

            // prepare for next time the dialog gets loaded
            self.find(".existing-image").attr("src", YouLi.Common.Utils.AddParametersToURL(existingImageNewURL, "fit=crop&crop=" + settings.CropType + (settings.ModalImageFieldHeight == "auto" ? "" : "&h=" + settings.ModalImageFieldHeight) + "&w=" + settings.ModalImageFieldWidth));
            self.find(".existing-image").attr("data-imageurl", existingImageNewURL);

            // Trigger Unsplash download location
            if (selectedImageDownloadLocation) {
                YouLi.Common.Get({
                    url: selectedImageDownloadLocation,
                    contentType: null,
                    suppressLoading: true,
                }).then(function () {
                });
            }

            if (settings.SuccessHandler !== undefined) {
                settings.SuccessHandler();
            }

            // YOULI-1776 if the following modal hide is done before the above success handler call, the removal of the modal-open class sometimes isn't triggered (the modal backdrop callback function isn't triggered), so let's just
            // do it after that line.  The reason appears to be because the success handler for avatar saving shows and hides the backdrop in itself.
            self.modal("hide");
        }

        var lastSearchTerm = "";

        function RefreshImagePreview(previewImageSelector, cropTargetPreview, addWithCrop) {

            //This function will refresh image preview either inside the popup or the target image outside the popup based on parameters passed
            var selectedImageURL = self.find("img.selected").attr("data-imageurl");

            var targetSelectedImage = selectedImageURL;

            var isUnsplashImage = self.find(".thumbnail-image-selectable.selected").attr("data-source") == "unsplash" || selectedImageURL.startsWith("http");

            var isCurrentImageInGlobalLibrary = self.find("#CurrentImageIsInGlobalImageLibrary").val() == "true";
            var displayURLPrefix = GetURLPrefix(isCurrentImageInGlobalLibrary)

            if (isUnsplashImage) {
                if (cropTargetPreview) {
                    targetSelectedImage = YouLi.Common.Utils.AddParametersToURL(targetSelectedImage, "ixlib=rb-0.3.5&q=80&fm=jpg&crop=" + settings.CropType + "&cs=tinysrgb" + (settings.TargetImageFieldHeight == "auto" ? "" : "&h=" + settings.TargetImageFieldHeight + "&w=" + settings.TargetImageFieldWidth + "&fit=crop"));
                }
                else {
                    targetSelectedImage = YouLi.Common.Utils.AddParametersToURL(targetSelectedImage, "ixlib=rb-0.3.5&q=80&fm=jpg&crop=" + settings.CropType + "&cs=tinysrgb&w=1080&fit=max");  // reduce down the size for display
                    if (addWithCrop) {
                        targetSelectedImage = YouLi.Common.Utils.AddParametersToURL(targetSelectedImage, "ixlib=rb-0.3.5&q=80&fm=jpg&crop=" + settings.CropType + "&cs=tinysrgb&w=1080&fit=max" + "&w=" + settings.TargetImageFieldWidth);
                    }
                }
            }
            else {
                if (cropTargetPreview) {
                    targetSelectedImage = YouLi.Common.Utils.AddParametersToURL(displayURLPrefix + selectedImageURL, "fit=crop&crop=" + settings.CropType + (settings.TargetImageFieldHeight == "auto" ? "" : "&h=" + settings.TargetImageFieldHeight + "&w=" + settings.TargetImageFieldWidth));
                }
                else {
                    targetSelectedImage = displayURLPrefix + selectedImageURL;
                    if (addWithCrop) { // will add width crop even if the crop to fit is not checked for the image embeded in popup
                        targetSelectedImage = YouLi.Common.Utils.AddParametersToURL(displayURLPrefix + selectedImageURL, "fit=crop&crop=" + settings.CropType + "&w=" + settings.TargetImageFieldWidth);
                    }
                }
            }

            $(previewImageSelector).attr("src", targetSelectedImage);
        }

        function RefreshImagePreviewInsidePopup() {
            if (settings.ShowCropToFitCheckbox) {
                var cropToFit = self.find("#ImageCheckboxCropToFit").is(":checked");
                RefreshImagePreview(self.find(".existing-image"), cropToFit, true);
            }
        }

        $(function () {
            YouLi.Common.UI.Init();

            if (settings.ShowCropToFitCheckbox) {
                //$('.update-image-crop-check').append("<div class='control--checkbox'><label class='control'>Crop to Fit? <input checked='checked' id='ImageCheckboxCropToFit' name='CropToFit' type='checkbox' value='true'><input name='CropToFit' type='hidden' value='false'><div class='control__indicator'></div></label></div>")
                self.find('.update-image-crop-check').removeClass('hidden')
            } else {
                //$('.update-image-crop-check').remove('.control--checkbox')
                self.find('.update-image-crop-check').addClass('hidden')
            }

            if (!settings.IncludeUnsplash) {
                self.find("#SearchPhotos").addClass("hidden");
            }

            // YOULI-10132 adding this button, but hiding it permanently until we do YOULI-10192
            if (settings.IsUsingGlobalImageLibraryFeature) {
                self.find("#SelectFromLibrary").off("click").on("click", function () {
                    window.Flmngr.open({
                        accessKey: "ZRJD231556E286DDB42A7F0C50BAD72B24CD",
                        apiKey: "ZRJDa7nT",
                        urlFileManager: settings.FileManagerURL,
                        urlFiles: settings.FileManagerFilesPrefix,
                        isMultiple: false,
                        acceptExtensions: ["png", "jpg", "jpeg", "gif", "webp"],
                        onFinish: (files) => {
                            const encodedUrl = files[0].url;
                            SetImageFromS3(encodedUrl);
                        }
                    });
                });
                self.find('.fileUpload').addClass("hidden");

                //force the script to load only when needed
                if (!window._flmngrScriptLoaded) {
                    $.getScript('https://unpkg.com/flmngr', function() {
                        // Script loaded and executed
                        window._flmngrScriptLoaded = true;
                    });
                }

                self.find("#PurgeImageCache").off("click").on("click", function () {
                    const urlPurge = "/planner/PurgeImageCache";
                    const imgUrl = $(this).data("img-url");
                    const $purgeBtn = $(this);

                    YouLi.Common.UI.ShowButtonLoading($purgeBtn);

                    YouLi.Common.Post({
                        url: urlPurge,
                        params: imgUrl
                    }).then(function (response) {
                        let queryParams = [
                            '?fit=crop&crop=entropy&h=400&w=600',
                            '?fit=crop&crop=entropy&h=100&w=100',
                            '?fit=crop&crop=entropy&h=30&w=30',
                            '?fit=crop&crop=entropy&w=600&h=400'];

                        return Promise.all(queryParams.map(function (value) {
                            return new Promise(function (resolve, reject) {
                                YouLi.Common.Get({
                                    url: imgUrl + value,
                                    contentType: null,
                                    cache: 'reload',
                                    suppressLoading: true,
                                    errorCallback: function () {
                                        reject(new Error('Failed to refresh image cache for ' + value));
                                    }
                                }).then(function (fetchResponse) {
                                    resolve(fetchResponse);
                                });
                            });
                        }));
                    }).then(function () {
                        YouLi.Common.UI.HideButtonLoading($purgeBtn);
                    })
                })
            }
            else {
                self.find("#SelectFromLibrary").remove();
                self.find("#PurgeImageCache").remove();
            }

            if (settings.HelpTipMessage !== "") {
                self.find("#UploadImageHelpText").removeClass("hidden").find(".helper-box-text").text(settings.HelpTipMessage);
            }

            // Initialise size of current image
            self.find(".edit-image-modal .thumbnail-image").css({
                "width": settings.ModalImageFieldWidth,
                "height": settings.ModalImageFieldHeight
            });

            self.off("show.bs.modal").on("show.bs.modal", function () {
                self.find(".thumbnail-image-selectable.selected").removeClass("selected");
                self.find(".existing-image").addClass("selected"); // initially select existing image
                self.find("#edit-image-modal-content").cslide();

                self.find("#SearchTerm").val("");

                self.find("#CurrentImage").off("load").on("load", function () {
                    $(this).removeClass("hidden");
                    YouLi.Common.UI.HideButtonLoading(self.find(".btn-done"));
                });

                $grid = self.find('.grid').masonry({
                    itemSelector: '.grid-item', // use a separate class for itemSelector, other than .col-
                    columnWidth: '.grid-sizer',
                    percentPosition: true
                });

                UpdateImagesFromUnsplash();
                self.find('.grid').masonry('layout');

                lastSearchTerm = "";

            });

            // YOULI-1776 the removal of the modal-open class isn't being triggered sometimes (the modal backdrop callback function isn't triggered), so let's just
            // clear it here.
            self.off("hide.bs.modal").on("hide.bs.modal", function () {
                $("body").removeClass('modal-open');
            });

            self.off('shown.bs.modal').on('shown.bs.modal', function () {
                if ($(settings.HiddenCropToTopSelector).val()) {
                    self.find("#ImageCheckboxCropToFit").prop('checked', $(settings.HiddenCropToTopSelector).val().toLowerCase() === 'true');
                    RefreshImagePreviewInsidePopup();
                }
            });

            self.off("change", ".edit-image-modal input[type='file']").on("change", ".edit-image-modal input[type='file']", function (e) {
                if (this.files.length >= 1) {
                    YouLi.Common.UI.ShowButtonLoading(self.find(".btn-done"));

                    // Get a fresh S3 policy every time (so a user can upload the same file more than once, e.g. after changing it on their computer)
                    YouLi.Common.Get({
                        url: settings.S3RefreshURL,
                        suppressLoading: true,
                        errorCallback: function () {
                            YouLi.Common.UI.ShowStandardDialog('An error occurred. Please refresh the page to try again.');
                            YouLi.Common.UI.HideButtonLoading(self.find('.btn-done'));
                        }
                    }).then(function (response) {
                        YouLi.Common.S3FileUpload.KeyPrefix = response.newKeyPrefix;

                        if (!settings.IsUsingGlobalImageLibraryFeature) {
                            YouLi.Common.S3FileUpload.KeyPrefix += response.newUUID;
                        }

                        YouLi.Common.S3FileUpload.Uuid = response.newUUID;
                        YouLi.Common.S3FileUpload.Policy = response.policy;
                        YouLi.Common.S3FileUpload.PolicySignature = response.policySignature;

                        self.uploadAttemptsCount = 0;

                        if (!YouLi.Common.S3FileUpload.SingleFileSelected(e.target, settings.ValidFileTypes, UploadSuccess, UploadError, UploadComplete)) {
                            YouLi.Common.UI.HideButtonLoading(self.find('.btn-done'));
                        }

                    });
                }
            });

            self.off("blur", "#SearchTerm").on("blur", "#SearchTerm", function () {

                // run search IF it hasn't already been run for this search term
                if (lastSearchTerm != $(this).val()) {
                    UpdateImagesFromUnsplash($(this).val());
                    lastSearchTerm = $(this).val();
                }
            });

            self.off("keyup", "#SearchTerm").on("keyup", "#SearchTerm", function (event) {
                if (event.keyCode == 13) {
                    // run search IF it hasn't already been run for this search term
                    if (lastSearchTerm != $(this).val()) {
                        UpdateImagesFromUnsplash($(this).val());
                        lastSearchTerm = $(this).val();
                    }
                }
            });

            self.off("click", ".thumbnail-image-selectable").on("click", ".thumbnail-image-selectable", function () {
                self.find(".thumbnail-image-selectable.selected").removeClass("selected")
                $(this).addClass("selected");
            });

            self.off("click", ".edit-image-modal-footer .btn-done").on("click", ".edit-image-modal-footer .btn-done", function () {
                SelectionDone();
            });

            self.off("dblclick", ".edit-image-modal .thumbnail-image-selectable").on("dblclick", ".edit-image-modal .thumbnail-image-selectable", function () {
                SelectionDone();
            });

            self.off("change", "#ImageCheckboxCropToFit").on("change", "#ImageCheckboxCropToFit", function () {
                RefreshImagePreviewInsidePopup();
            });

            if (settings.CropToFitHoverText) {
                $(".update-image-crop-check")
                    .attr("data-toggle", "popover")
                    .attr("data-container", "body")
                    .attr("data-placement", "bottom")
                    .attr("data-trigger", "hover")
                    .attr("data-content", settings.CropToFitHoverText)
                    .popover();
            }
        });

        return this;
    };

}(jQuery));